import type { Dayjs } from 'dayjs'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { CustomTimePicker } from '@/components/ui/custom-time-picker'

interface TimeRangePickerRowProps {
  from?: Dayjs
  to?: Dayjs
  onFromChange: (value?: Dayjs) => void
  onToChange: (value?: Dayjs) => void
  fromLabel?: string
  toLabel?: string
  fromPlaceholder?: string
  toPlaceholder?: string
  readOnly?: boolean
  showRemove?: boolean
  onRemove?: () => void
  removeDisabled?: boolean
  className?: string
}

export function TimeRangePickerRow({
  from,
  to,
  onFromChange,
  onToChange,
  fromLabel = 'Từ:',
  toLabel = 'Đến:',
  fromPlaceholder = '08:00 AM',
  toPlaceholder = '12:00 PM',
  readOnly = false,
  showRemove = false,
  onRemove,
  removeDisabled = false,
  className,
}: TimeRangePickerRowProps) {
  return (
    <div
      className={[
        showRemove
          ? 'grid grid-cols-[1fr_1fr_auto] items-center gap-2'
          : 'grid grid-cols-2 items-center gap-3',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="grid grid-cols-[48px_1fr] items-center gap-2">
        <span className="text-sm text-gray-600">{fromLabel}</span>
        <CustomTimePicker
          value={from}
          onChange={(time) => onFromChange(time ?? undefined)}
          format="hh:mm A"
          use12Hours
          placeholder={fromPlaceholder}
          className="h-[34px]"
          inputReadOnly={readOnly}
          open={readOnly ? false : undefined}
        />
      </div>

      <div className="grid grid-cols-[48px_1fr] items-center gap-2">
        <span className="text-sm text-gray-600">{toLabel}</span>
        <CustomTimePicker
          value={to}
          onChange={(time) => onToChange(time ?? undefined)}
          format="hh:mm A"
          use12Hours
          placeholder={toPlaceholder}
          className="h-[34px]"
          inputReadOnly={readOnly}
          open={readOnly ? false : undefined}
        />
      </div>

      {showRemove && (
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full text-[#E05B5B] hover:bg-[#feecec]"
          onClick={onRemove}
          disabled={removeDisabled}
        >
          <X size={14} />
        </Button>
      )}
    </div>
  )
}
